interface Props {
  label?: string;
}

/**
 * ページラベル帯（Figma の "カタログ" / "スレッド" 等が書かれているオレンジバンド）。
 */
export const PageLabelBand: React.FunctionComponent<Props> = ({
  label,
}: Props) => {
  if (!label) return null;
  return (
    <div className="bg-accent text-accent-foreground text-center py-1 text-sm font-bold">
      {label}
    </div>
  );
};
